<template>
  <footer class="player-footer">
    <div class="d-flex flex-wrap player-footer-content">
      <span class="player-global-controls d-flex align-items-center justify-content-around text-center w-xs-100">
        <svg-icon
          class="mix-play-icon"
          v-if="showPlay"
          src="/images/play_circle.svg"
          alt="play"
          @click.prevent="emit('play')"
        />
        <svg-icon
          class="mix-play-icon"
          v-else
          src="/images/pause_circle.svg"
          alt="pause"
          @click.prevent="emit('pause')"
        />
        <svg-icon
          class="mix-play-icon"
          :class="controlsDisabled"
          src="/images/back_circle.svg"
          alt="previous track"
          @click.prevent="emit('previous')"
        />
        <svg-icon
          class="mix-play-icon"
          :class="controlsDisabled"
          src="/images/back15.svg"
          alt="back 15 seconds"
          @click.prevent="emit('back15')"
        />
        <svg-icon
          class="mix-play-icon"
          :class="controlsDisabled"
          src="/images/forward15.svg"
          alt="forward 15 seconds"
          @click.prevent="emit('forward15')"
        />
        <svg-icon
          class="mix-play-icon"
          :class="controlsDisabled"
          src="/images/forward_circle.svg"
          alt="next track"
          @click.prevent="emit('next')"
        />
        <svg-icon
          class="mix-play-icon d-sm-none"
          @click.prevent="shareClick"
          src="/images/share-plane-circle.svg"
          alt="share"
        />
      </span>
      <span
        class="d-flex w-xs-100 flex-grow-1 justify-content-center align-items-center mt-2 mt-sm-0 p-0"
        id="song-title-container"
      >
        <span class="song-title me-5">{{ title }}</span>
        <player-time class="global-seek-time" />
      </span>
      <span v-if="showActions" class="upload-share d-none d-sm-flex">
        <router-link to="/mixes/new">
          <svg-icon class="footer-plus-icon" src="/images/upload.svg" alt="upload mix" /> Upload
        </router-link>
        <a class="footer-share-link" href="#" @click.prevent="shareClick">
          <svg-icon class="footer-share-icon" src="/images/share-plane.svg" @click.prevent="shareClick" alt="share" />
          Share
        </a>
      </span>
    </div>
  </footer>
</template>
<style scoped>
.upload-share {
  align-items: center;
  font-size: 1.2rem;
}

.player-footer {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background: #333;
  position: fixed;
  z-index: 20;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0px 10px 0px;
  color: white;
}

.player-footer a {
  text-decoration: none;
}

.player-footer .mix-play-icon {
  margin-right: 10px;
}

.player-footer .mix-play-icon.disabled {
  color: #666;
}

.player-footer .song-title {
  font-size: 1.5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.player-footer .global-seek-time {
  font-size: 1.3rem;
  font-family: monospace;
  cursor: ew-resize;
}

.player-footer-content {
  width: 100%;
  margin-left: 20px;
  margin-right: 20px;
}


.no-sidebar .player-footer-content {
  max-width: 1100px;
}
@media (max-width: 576px) {
  .w-xs-100 {
    width: 100%;
  }
}

#song-title-container {
  display: none;
}
</style>

<style>
.footer-plus-icon svg {
  height: 1.2rem;
}

.footer-share-icon svg {
  height: 1.2rem;
  margin-left: 20px;
}
</style>

<script>
import bus from "../bus.js"
import PlayerTime from "./player_time.vue"

export default {
  components: { PlayerTime },
  data() {
    return {
      title: "...",
      currentState: undefined,
      currentTime: null,
    }
  },
  methods: {
    emit(ev) {
      console.log("emitting", ev)
      bus.emit("player-control", ev)
    },
    shareClick() {
      bus.emit("open-share", { shareChoice: true })
    },
  },
  computed: {
    controlsDisabled() {
      return { disabled: this.currentState === undefined || this.currentState == "pause" }
    },
    showPlay() {
      return this.currentState === undefined || this.currentState == "pause"
    },
    showActions() {
      return mmmGlobals.logged_in
    }
  },
  mounted() {
    bus.on("player-state-change", payload => {
      this.currentState = payload
    })
    bus.on("player-current-title", title => (this.currentTitle = title))
    bus.on("player-time-update", payload => {
      this.title = payload.mix.name_and_version.join(" ")
      this.currentTime = payload.time
    })
  },
}
</script>
